import { Record } from "immutable";
import moment from "moment";

const defaults = {
    key: undefined,
    messages: [],
};

interface IChatMessage {
    timestamp_ms: moment.Moment;
    id: string;
    thread_id: string;
    namespace: string;
    identity: string;
    identity_type: string;
    kind: string;
    content: string;
}

export class ChatMessage extends Record(defaults) {
    declare key: string;
    declare messages: [IChatMessage];

    constructor(args) {
        super({
            ...args,
            messages: (args.messages || []).map((message) => ({
                ...message,
                timestamp_ms: moment.isMoment(message.timestamp_ms)
                    ? message.timestamp_ms
                    : moment.utc(parseInt(message.timestamp_ms, 10)),
            })),
        });
    }
}
